import React, { useState, useEffect } from "react";
import { FormattedMessage } from "react-intl";
import _ from "lodash";
import TrashIcon from "@mui/icons-material/DeleteSweepTwoTone";
import { useLocation, useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import mapSalesCreationDataToMixPanel from "modules/clientProjects/mapDataToMixpanel";
import { EuiSwitch } from "@elastic/eui";
import { checkIsObjectEmpty } from "utils/checkEmptyValues";
import { useMapDataToUiWithFilter } from "hooks/mapDataToOptions";
import {
    getClientById,
    getTruckTypeList,
    getPickupList,
    getConstantsList,
    submitProfileForm,
    getStandardsAndProceduresList,
} from "../../api";
import Input from "../../../../components/input";
import SelectWithSearch from "../../../../components/selectWithSearch";
import { mapOptionsToUi, mapConstantsToUi, filterArrayByString } from "../../mapToUi";
import DatePickerInput from "../../../../components/datePicker";
import TextArea from "../../../../components/textArea";
import CheckBox from "../../../../components/checkbox";
import DatePickerTimeOnlyInput from "../../../../components/datePickerTimeOnly";
import Button from "../../../../components/button";
import {
    SeparateLine,
    ButtonRow,
    ProjectInfo,
    WorkingConditionSteps,
    MileageUnit,
    MileageInput,
    DataView,
    ProjectFinancialLegalContainer,
    ConditionSteps,
    ProjectCondition,
} from "../../../../styles/elements/main";
import { FormGroup, FormRow, FormStyle, Error, StyledLabel } from "../../../../styles/forms/main";
import { mapSalesFormToData } from "../../mapToData";
import { setMessage } from "../../../shared/notification/slice";
import trackAnalytics from "../../../../trackAnalytics";
import { isEmpty } from "../../../shared/utils/checkIsEmptyArray";
import ProjectFinancialLegal from "../ProjectFinancialLegal";
import QADetails from "../QADetails";
import Spinner from "../../../../components/Spinner";
import { AddWorkingCondition, ConfirmSpo, ErrorHint, TrashIconStyle } from "../../styles";
import ExtraOperationalRequirements from "../ExtraOperationalRequirements";
export default function CreateProjectForm() {
    const [clientName, setClientName] = useState({ value: "", label: "" });
    const [projectType, setProjectType] = useState({ value: 0, label: "Monthly" });
    const [date, setDate] = useState(null);
    const [isRfq, setIsRfq] = useState(false);
    // Operations QA details
    const [operationalAttachments, setOperationalAttachments] = useState([]);
    const [qaDetails, setQaDetails] = useState({
        requireDocumentsCollection: false,
        standardsAndOperationalProcedures: [],
        neededDocumentsType: [],
        requiresIllaOperatorsInClientPremises: false,
    });
    //
    const [truckTypesList, setTruckTypesList] = useState([]);
    const [pickupList, setPickupList] = useState([]);
    const [salesList, setSalesList] = useState([]);
    const [standardsAndProceduresList, setStandardsAndProceduresList] = useState([]);
    const [weekDayList, setWeekDayList] = useState([]);
    const [serviceArea, setServiceArea] = useState([]);
    const [workingConditions, setWorkingConditions] = useState([
        {
            truckType: null,
            numberOfTruck: 0,
            hasPreferredModelYear: false,
            requiredModelYearStartsFrom: null,
            truckTypeCheckbox: false,
            KickOffDate: null,
            endDate: null,
            salesChannels: [],
            workingArea: [],
            pickupLocation: null,
            pickupArrivalTime: null,
            weeklyOffDays: [],
            workingDaysPerMonth: 0,
            workingHoursPerDay: 0,
            kiloMeters: 0,
            numberOfHelpers: 0,
            numberOfDelegates: 0,
            facilitiesCheckbox: false,
            facilitiesSpecialRequired: "",
            truckPricePerMonth: "",
            extraDayPrice: "",
            extraHoursPrice: "",
            extraKiloMeterPrice: "",
            overNightPrice: "",
            truckDailyPrice: "",
            excludeGasAndOil: false,
            helperWage: 0,
            delegateWage: 0,
            goodsTransfer: false,
            cashCollection: false,
            distribution: false,
            scales: false,
            tolls: false,
            returnable: false,
            workingOvernight: false,
            workingOnHolidays: false,
            specialExtraOperationalRequirments: "",
        },
    ]);
    // eslint-disable-next-line no-unused-vars
    const [workingCondition, setWorkingCondition] = useState({
        truckType: null,
        numberOfTruck: 0,
        hasPreferredModelYear: false,
        requiredModelYearStartsFrom: null,
        truckTypeCheckbox: false,
        KickOffDate: null,
        endDate: null,
        salesChannels: [],
        workingArea: [],
        pickupLocation: null,
        pickupArrivalTime: null,
        weeklyOffDays: [],
        workingDaysPerMonth: 0,
        workingHoursPerDay: 0,
        kiloMeters: 0,
        operationalDetailsCheckbox: false,
        operationalDetailsSpecialRequired: "",
        numberOfHelpers: 0,
        numberOfDelegates: 0,
        facilitiesCheckbox: false,
        facilitiesSpecialRequired: "",
        truckPricePerMonth: "",
        extraDayPrice: "",
        extraHoursPrice: "",
        extraKiloMeterPrice: "",
        overNightPrice: "",
        truckDailyPrice: "",
        excludeGasAndOil: false,
        helperWage: 0,
        delegateWage: 0,
        goodsTransfer: false,
        cashCollection: false,
        distribution: false,
        scales: false,
        tolls: false,
        returnable: false,
        workingOvernight: false,
        workingOnHolidays: false,
        specialExtraOperationalRequirments: "",
    });
    const [activeWorkingCondition, setActiveWorkingCondition] = useState(0);
    const [formIsValid, setFormIsValid] = useState(true);
    const [confirmSops, setConfirmSops] = useState(false);
    const [workingConditionIsValid, setWorkingConditionIsValid] = useState();
    const [organizationId, setOrganizationId] = useState("");
    const [clickOnSubmit, setClickOnSubmit] = useState(false);
    const location = useLocation();
    const history = useHistory();
    const dispatch = useDispatch();
    const [projectFinancialLegal, setProjectFinancialLegal] = useState({});
    const [salesContracts, setSalesContracts] = useState([]);
    const [projectName, setProjectName] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [targetPriceAttachments, setTargetPriceAttachments] = useState([]);
    const [deductionsValues, setDeductionsValues] = useState({});
    const [allIllaDeductions, setAllIllaDeductions] = useState([]);
    const [allClientDeductions, setAllClientDeductions] = useState([]);
    const [openTime, setOpenTime] = useState(null);
    const {
        data: organizations,
        setSearchFilter: setOrganizationsFilter,
        clearSearchFilter: clearOrganizationsFilter,
    } = useMapDataToUiWithFilter("organizations");

    const fetchOrganizations = async (id) => {
        const data = await getClientById(id);
        setClientName({
            label: _.values(data?.entities["organizations"])[0]["attributes"].name,
            value: id,
        });
    };

    useEffect(() => {
        const timeNow = new Date();
        setOpenTime(timeNow);
    }, []);

    useEffect(() => {
        if (location?.state?.OrganizationId) {
            setOrganizationId(location?.state?.OrganizationId);
            fetchOrganizations(location?.state?.OrganizationId);
        }
        trackAnalytics(location?.pathname);
        return;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location]);

    // eslint-disable-next-line consistent-return
    const fetchTruckTypes = async (filterValue) => {
        const data = await getTruckTypeList(filterValue);

        if (
            filterValue &&
            mapOptionsToUi(_.values(data.entities["truckTypes"]), "id", "alias").length > 0
        ) {
            return mapOptionsToUi(_.values(data.entities["truckTypes"]), "id", "alias");
        }
        if (!filterValue) {
            setTruckTypesList(mapOptionsToUi(_.values(data.entities["truckTypes"]), "id", "alias"));
        }
    };

    const fetchPickUpList = async (filterValue) => {
        const data = await getPickupList(filterValue, organizationId);
        setPickupList(mapOptionsToUi(_.values(data?.entities["branches"]), "locationId", "nameEn"));
        return mapOptionsToUi(_.values(data?.entities["branches"]), "locationId", "nameEn");
    };

    const fetchConstantsList = async () => {
        const { data } = await getConstantsList();
        setSalesList(mapConstantsToUi(data["sales_channels"], "key", "nameEn"));
        setWeekDayList(mapConstantsToUi(data["week_days"], "key", "nameEn"));
        setServiceArea(mapConstantsToUi(data["service_areas"], "key", "nameEn"));
    };
    const fetchStandardsAndProcedures = async () => {
        const data = await getStandardsAndProceduresList();
        setStandardsAndProceduresList(
            mapOptionsToUi(
                _.values(data?.entities["standardsAndOperationalProcedures"]),
                "id",
                "description"
            )
        );
    };

    useEffect(() => {
        setClickOnSubmit(false);
        fetchTruckTypes();
        fetchPickUpList();
        fetchConstantsList();
        fetchStandardsAndProcedures();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [organizationId]);

    const addWorkingCondition = () => {
        setWorkingConditions([...workingConditions, workingCondition]);
        setActiveWorkingCondition(workingConditions.length);
    };
    const filterSalesList = (filterValue) => filterArrayByString(salesList, filterValue);
    const deleteWorkingCondition = () => {
        const newConditions = workingConditions.filter(
            (item, index) => index !== activeWorkingCondition
        );
        setWorkingConditions(newConditions);
        setActiveWorkingCondition(0);
    };

    const checkFinancialLegalIsValid = () => {
        if (
            isEmpty([
                projectFinancialLegal.ClientCollection,
                projectFinancialLegal.invoicing,
                projectFinancialLegal.PODs,
            ]) ||
            ((projectFinancialLegal.illaDeductions || projectFinancialLegal?.clientDeductions) &&
                checkIsObjectEmpty(deductionsValues))
        ) {
            return false;
        }
        return true;
    };
    const checkWorkingConditionValidation = () => {
        setClickOnSubmit(false);
        let validateWorkingCondition = true;
        // eslint-disable-next-line array-callback-return
        workingConditions.map((item) => {
            if (
                isEmpty([
                    item.truckType,
                    item?.KickOffDate,
                    item?.pickupLocation,
                    item?.pickupArrivalTime,
                ]) ||
                item?.numberOfTruck === 0 ||
                item?.salesChannels.length === 0 ||
                item?.workingArea.length === 0 ||
                item?.weeklyOffDays.length === 0 ||
                (item?.weeklyOffDays.length > 1 &&
                    item?.weeklyOffDays?.some((value) => value?.label?.toLowerCase() === "none")) ||
                item?.workingDaysPerMonth === 0 ||
                item?.workingHoursPerDay === 0 ||
                (item?.excludeGasAndOil && item?.gasAndOilPerUnitDistance === 0) ||
                (!isRfq && item?.truckPricePerMonth === 0) ||
                (!isRfq && item?.extraDayPrice === 0) ||
                (!isRfq && item?.extraHoursPrice === 0) ||
                (!isRfq && item?.extraKiloMeterPrice === 0) ||
                (item?.workingOvernight && item?.overNightPrice === 0) ||
                (!isRfq && item.numberOfHelpers > 0 && item?.helperWage === 0) ||
                (!isRfq && item.numberOfDelegates > 0 && item?.delegateWage === 0) ||
                (item.hasPreferredModelYear && item?.requiredModelYearStartsFrom === null) ||
                !checkFinancialLegalIsValid()
            ) {
                validateWorkingCondition = false;
            } else {
                validateWorkingCondition = true;
            }
            setWorkingConditionIsValid(validateWorkingCondition);
        });
    };

    const checkFormValidation = (e) => {
        e.preventDefault();
        checkWorkingConditionValidation();
        setClickOnSubmit(true);
    };

    const handleSubmitForm = async () => {
        setIsLoading(true);
        const FormData = await mapSalesFormToData(
            salesContracts,
            projectFinancialLegal,
            workingConditions,
            organizationId,
            date,
            confirmSops,
            isRfq,
            projectName,
            projectType,
            qaDetails,
            operationalAttachments,
            targetPriceAttachments,
            deductionsValues
        );
        const mixPanelAttributes = mapSalesCreationDataToMixPanel(FormData?.data, openTime);
        if (FormData) {
            submitProfileForm(FormData)
                .then(async (res) => {
                    const response = await res;
                    // eslint-disable-next-line prefer-destructuring
                    const id = _.values(response.entities["projects"])[0].id;
                    setFormIsValid(true);
                    trackAnalytics("Submit new project profile - Sales", mixPanelAttributes);
                    setIsLoading(false);
                    dispatch(
                        setMessage({
                            content: `project created successfully `,
                            isError: false,
                        })
                    );
                    history.push({
                        pathname: `/clientProjects/${id}`,
                        state: { projectId: id, clientId: organizationId },
                    });
                })
                .catch((error) => {
                    setIsLoading(false);
                    setClickOnSubmit(false);
                    setFormIsValid(false);
                    trackAnalytics("Failure Project Submissions");

                    dispatch(
                        setMessage({
                            content: error,
                            title: `Couldn't create project profile  `,
                            isError: true,
                        })
                    );
                });
        }
    };

    useEffect(() => {
        if (clickOnSubmit) {
            if (
                clientName?.value === "" ||
                date === null ||
                confirmSops === false ||
                projectName === "" ||
                !workingConditionIsValid
            ) {
                setFormIsValid(false);
            } else {
                setFormIsValid(true);
                handleSubmitForm();
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [workingConditionIsValid, clickOnSubmit]);

    const handleOnChangeSelect = (e, valueName) => {
        setWorkingConditions([
            ...(workingConditions?.map((condition, indexCondition) => {
                if (indexCondition === activeWorkingCondition) {
                    return {
                        ...condition,
                        [valueName]: e,
                    };
                }
                return condition;
            }) || []),
        ]);
    };
    const handleOnChangeInput = (e, valueName) => {
        setWorkingConditions([
            ...(workingConditions?.map((condition, indexCondition) => {
                if (indexCondition === activeWorkingCondition) {
                    return {
                        ...condition,
                        [valueName]: e.target.value,
                    };
                }
                return condition;
            }) || []),
        ]);
    };
    const handleOnChangeCheckBox = (e, valueName) => {
        setWorkingConditions([
            ...(workingConditions?.map((condition, indexCondition) => {
                if (indexCondition === activeWorkingCondition) {
                    return {
                        ...condition,
                        [valueName]: e?.target?.checked,
                    };
                }
                return condition;
            }) || []),
        ]);
    };
    const handleOnChangeTimeOnly = (e, valueName) => {
        setWorkingConditions([
            ...(workingConditions?.map((condition, indexCondition) => {
                if (indexCondition === activeWorkingCondition) {
                    return {
                        ...condition,
                        [valueName]: e,
                    };
                }
                return condition;
            }) || []),
        ]);
    };
    return (
        <FormStyle onSubmit={checkFormValidation}>
            <ProjectInfo>
                <h2>
                    <FormattedMessage id="client.project-create-header" />
                </h2>
                <FormRow>
                    <FormGroup>
                        <SelectWithSearch
                            isEditable={!location?.state?.OrganizationId}
                            isMulti={false}
                            label="Client name"
                            options={organizations}
                            handleChange={(e) => {
                                setOrganizationId(e?.value);
                                setClientName(e);
                                clearOrganizationsFilter();
                            }}
                            handleFilter={(filter) => {
                                setOrganizationsFilter(filter);
                                return organizations;
                            }}
                            value={clientName?.label && clientName}
                            name="clientName"
                            placeholder="Client name"
                            required="true"
                            error={!formIsValid && clientName?.label === ""}
                        />
                    </FormGroup>
                    <FormGroup>
                        <Input
                            isEditable
                            label="project Name"
                            name="projectName"
                            type="text"
                            onChange={(e) => {
                                setProjectName(e?.target?.value);
                            }}
                            required
                            placeholder=""
                            value={projectName}
                            error={!formIsValid && projectName === ""}
                        />
                    </FormGroup>
                </FormRow>
                <FormRow>
                    <FormGroup>
                        <SelectWithSearch
                            isEditable
                            isMulti={false}
                            label="Project Type"
                            options={[
                                { value: 0, label: "Monthly" },
                                { value: 1, label: "Daily Rental" },
                            ]}
                            handleChange={(e) => {
                                setProjectType(e);
                            }}
                            value={projectType}
                            name="projectType"
                            placeholder="Project Type"
                            required
                            error={!formIsValid && projectType?.label === ""}
                        />
                    </FormGroup>
                    <FormGroup>
                        <DatePickerInput
                            isEditable
                            name="datePicker"
                            selectedValue={date}
                            onChange={(e) => setDate(e)}
                            required="true"
                            label="Client Request Date"
                            dateFormat="dd/MM/yyyy h:mma"
                        />
                    </FormGroup>
                </FormRow>
                <FormRow>
                    <EuiSwitch
                        label="Request For Quotation “provide pricing details”"
                        checked={isRfq}
                        onChange={(e) => setIsRfq(e.target.checked)}
                    />
                </FormRow>
                <ProjectFinancialLegalContainer>
                    <ProjectFinancialLegal
                        key="createLegalSection"
                        setFinancialLegal={(fieldName, value) => {
                            setProjectFinancialLegal({
                                ...projectFinancialLegal,
                                [fieldName]: value,
                            });
                        }}
                        projectFinancialLegal={projectFinancialLegal}
                        isEditable
                        formIsValid={formIsValid}
                        isView={false}
                        setSalesAttachments={(uploadedFiles) => {
                            setSalesContracts(uploadedFiles);
                        }}
                        setTargetPriceAttachments={(uploadedFiles) => {
                            setTargetPriceAttachments(uploadedFiles);
                        }}
                        userRole="sales"
                        isCreate
                        setAllIllaDeductions={setAllIllaDeductions}
                        setAllClientDeductions={setAllClientDeductions}
                        allIllaDeductions={allIllaDeductions}
                        allClientDeductions={allClientDeductions}
                        deductionsValues={deductionsValues}
                        setDeductionsValues={setDeductionsValues}
                    />
                </ProjectFinancialLegalContainer>
                <SeparateLine />
                <div>
                    <QADetails
                        setOperationalAttachments={setOperationalAttachments}
                        qADetails={qaDetails}
                        setQaDetails={setQaDetails}
                        standardsAndProceduresList={standardsAndProceduresList}
                        isCreate
                    />
                    <SeparateLine />
                </div>
            </ProjectInfo>
            <div>
                <WorkingConditionSteps>
                    {workingConditions?.map((item, index) => (
                        <ConditionSteps
                            className={index === activeWorkingCondition ? "active" : ""}
                            onClick={() => setActiveWorkingCondition(index)}
                        >
                            Working condition {index + 1}
                        </ConditionSteps>
                    ))}
                    <AddWorkingCondition onClick={addWorkingCondition}>
                        <span>+</span>
                    </AddWorkingCondition>
                </WorkingConditionSteps>
                <ProjectCondition>
                    {workingConditions.length > 1 && (
                        <TrashIconStyle>
                            <TrashIcon onClick={deleteWorkingCondition} />
                        </TrashIconStyle>
                    )}
                    <div>
                        <h3>Truck Details</h3>
                        <FormRow>
                            <FormGroup>
                                <SelectWithSearch
                                    isEditable
                                    isMulti={false}
                                    label="Truck Type"
                                    options={truckTypesList}
                                    handleFilter={(value) => filterArrayByString(salesList, value)}
                                    handleChange={(e) => {
                                        handleOnChangeSelect(e, "truckType");
                                    }}
                                    value={workingConditions[activeWorkingCondition].truckType}
                                    name="truckType"
                                    placeholder="Truck Type"
                                    required
                                    error={
                                        !formIsValid &&
                                        workingConditions[activeWorkingCondition]?.truckType ===
                                            null &&
                                        (workingConditions[activeWorkingCondition]?.truckTypeId ===
                                            "" ||
                                            workingConditions[activeWorkingCondition]
                                                ?.truckTypeId === null ||
                                            workingConditions[activeWorkingCondition]
                                                ?.truckTypeId === undefined)
                                    }
                                />
                            </FormGroup>
                            <FormGroup>
                                <Input
                                    isEditable
                                    label="Number Of Trucks"
                                    name="numberOfTrucks"
                                    type="number"
                                    onChange={(e) => {
                                        handleOnChangeInput(e, "numberOfTruck");
                                    }}
                                    required
                                    placeholder="0"
                                    value={workingConditions[activeWorkingCondition]?.numberOfTruck}
                                    min="1"
                                    error={
                                        !formIsValid &&
                                        workingConditions[activeWorkingCondition]?.numberOfTruck ===
                                            0
                                    }
                                />
                            </FormGroup>
                        </FormRow>
                        <FormRow>
                            <FormGroup>
                                <CheckBox
                                    label="Do you prefer specific truck model ?"
                                    name="hasPreferredModelYear"
                                    type="checkbox"
                                    borderd
                                    onChange={(e) => {
                                        handleOnChangeCheckBox(e, "hasPreferredModelYear");
                                    }}
                                    value={
                                        workingConditions[activeWorkingCondition]
                                            ?.hasPreferredModelYear || false
                                    }
                                />
                            </FormGroup>
                            {workingConditions[activeWorkingCondition]?.hasPreferredModelYear && (
                                <FormGroup>
                                    <SelectWithSearch
                                        isEditable
                                        label="Required model year starts from "
                                        options={
                                            // years from 1980 to the current year
                                            Array.from(
                                                new Array(new Date().getFullYear() - 1980 + 1),
                                                (val, index) => index + 1980
                                            ).map((year) => ({
                                                value: year,
                                                label: year,
                                            }))
                                        }
                                        handleChange={(e) => {
                                            handleOnChangeSelect(e, "requiredModelYearStartsFrom");
                                        }}
                                        value={
                                            workingConditions[activeWorkingCondition]
                                                ?.requiredModelYearStartsFrom
                                        }
                                        name="requiredModelYearStartsFrom"
                                        placeholder="Select Year"
                                        required={
                                            workingConditions[activeWorkingCondition]
                                                ?.hasPreferredModelYear
                                        }
                                        error={
                                            !formIsValid &&
                                            workingConditions[activeWorkingCondition]
                                                ?.requiredModelYearStartsFrom === null
                                        }
                                    />
                                </FormGroup>
                            )}
                        </FormRow>
                        <SeparateLine />
                    </div>
                    <ExtraOperationalRequirements
                        workingCondition={workingConditions[activeWorkingCondition]}
                        onChange={(value, attribute) => {
                            handleOnChangeSelect(value, attribute);
                        }}
                        isEditable
                    />
                    <div>
                        <h3>Client Operational Details</h3>
                        <FormRow>
                            <FormGroup>
                                <DatePickerInput
                                    isEditable
                                    name="KickOffDate"
                                    selectedValue={
                                        workingConditions[activeWorkingCondition]?.KickOffDate
                                    }
                                    onChange={(e) => {
                                        handleOnChangeSelect(e, "KickOffDate");
                                    }}
                                    required="true"
                                    label="Kick-off Date"
                                    dateFormat="dd/MM/yyyy h:mma"
                                />
                            </FormGroup>
                            <FormGroup>
                                <DatePickerInput
                                    isEditable
                                    name="endDate"
                                    selectedValue={
                                        workingConditions[activeWorkingCondition]?.endDate
                                    }
                                    onChange={(e) => {
                                        handleOnChangeSelect(e, "endDate");
                                    }}
                                    required="true"
                                    label="End Date"
                                    dateFormat="dd/MM/yyyy h:mma"
                                />
                            </FormGroup>
                        </FormRow>
                        <FormGroup>
                            <Input
                                isEditable
                                label="Maximum number of drop-offs"
                                name="maximumNumberOfDropOff"
                                type="number"
                                onChange={(e) => {
                                    handleOnChangeInput(e, "maximumNumberOfDropOff");
                                }}
                                required
                                placeholder="0"
                                value={
                                    workingConditions[activeWorkingCondition]
                                        ?.maximumNumberOfDropOff || ""
                                }
                                min="1"
                                error={
                                    !formIsValid &&
                                    (workingConditions[activeWorkingCondition]
                                        ?.maximumNumberOfDropOff === "" ||
                                        workingConditions[activeWorkingCondition]
                                            ?.maximumNumberOfDropOff === null ||
                                        workingConditions[activeWorkingCondition]
                                            ?.maximumNumberOfDropOff === undefined)
                                }
                            />
                        </FormGroup>
                        <FormRow>
                            <FormGroup>
                                <SelectWithSearch
                                    isEditable
                                    isMulti
                                    label="Sales Channels"
                                    options={salesList}
                                    handleFilter={(value) => filterSalesList(value)}
                                    handleChange={(e) => {
                                        handleOnChangeSelect(e, "salesChannels");
                                    }}
                                    value={workingConditions[activeWorkingCondition]?.salesChannels}
                                    name="salesChannels"
                                    placeholder="Sales Channels"
                                    required
                                    error={
                                        !formIsValid &&
                                        workingConditions[activeWorkingCondition]?.salesChannels
                                            .length === 0
                                    }
                                />
                            </FormGroup>
                            <FormGroup>
                                <SelectWithSearch
                                    isEditable
                                    isMulti
                                    label="Working Area"
                                    options={serviceArea}
                                    handleFilter={(value) =>
                                        filterArrayByString(serviceArea, value)
                                    }
                                    handleChange={(e) => {
                                        handleOnChangeSelect(e, "workingArea");
                                    }}
                                    value={workingConditions[activeWorkingCondition]?.workingArea}
                                    name="workingArea"
                                    placeholder="Working Area"
                                    required
                                    error={
                                        !formIsValid &&
                                        workingConditions[activeWorkingCondition]?.workingArea
                                            .length === 0
                                    }
                                />
                            </FormGroup>
                        </FormRow>
                        <FormRow>
                            <FormGroup>
                                <SelectWithSearch
                                    isEditable
                                    isMulti={false}
                                    label="Pickup Location"
                                    options={pickupList}
                                    handleFilter={(value) => fetchPickUpList(value)}
                                    handleChange={(e) => {
                                        handleOnChangeSelect(e, "pickupLocation");
                                    }}
                                    value={
                                        workingConditions[activeWorkingCondition]?.pickupLocation
                                    }
                                    name="PickupLocation"
                                    placeholder="Pickup Location"
                                    required
                                    error={
                                        !formIsValid &&
                                        workingConditions[activeWorkingCondition]
                                            ?.pickupLocation === null &&
                                        (workingConditions[activeWorkingCondition]
                                            ?.pickupLocationId === "" ||
                                            workingConditions[activeWorkingCondition]
                                                ?.pickupLocationId === null ||
                                            workingConditions[activeWorkingCondition]
                                                ?.pickupLocationId === undefined)
                                    }
                                />
                            </FormGroup>
                            <FormGroup>
                                <DatePickerTimeOnlyInput
                                    isEditable
                                    name="pickupArrivalTime"
                                    selectedValue={
                                        workingConditions[
                                            activeWorkingCondition
                                        ]?.pickupArrivalTime?.getTime() || ""
                                    }
                                    onChange={(e) => handleOnChangeTimeOnly(e, "pickupArrivalTime")}
                                    required="true"
                                    label="Pickup Arrival Time"
                                    dateFormat="h:mm aa"
                                    error={
                                        !formIsValid &&
                                        (workingConditions[activeWorkingCondition]
                                            ?.pickupArrivalTime === "" ||
                                            workingConditions[activeWorkingCondition]
                                                ?.pickupArrivalTime === null ||
                                            workingConditions[activeWorkingCondition]
                                                ?.pickupArrivalTime === undefined)
                                    }
                                />
                            </FormGroup>
                        </FormRow>
                        <FormRow>
                            <FormGroup>
                                <SelectWithSearch
                                    isEditable
                                    isMulti
                                    label="Weekly Off Days"
                                    options={weekDayList}
                                    handleFilter={(value) =>
                                        filterArrayByString(weekDayList, value)
                                    }
                                    handleChange={(e) => {
                                        handleOnChangeSelect(e, "weeklyOffDays");
                                    }}
                                    value={workingConditions[activeWorkingCondition].weeklyOffDays}
                                    name="weeklyOffDays"
                                    placeholder="Weekly Off Days"
                                    required
                                    error={
                                        !formIsValid &&
                                        (workingConditions[activeWorkingCondition]?.weeklyOffDays
                                            ?.length === 0 ||
                                            (workingConditions[activeWorkingCondition].weeklyOffDays
                                                ?.length > 1 &&
                                                workingConditions[
                                                    activeWorkingCondition
                                                ].weeklyOffDays?.some(
                                                    (value) =>
                                                        value?.label?.toLowerCase() === "none"
                                                )))
                                    }
                                    errorMsg={
                                        !formIsValid &&
                                        workingConditions[activeWorkingCondition]?.weeklyOffDays
                                            ?.length > 1 &&
                                        workingConditions[
                                            activeWorkingCondition
                                        ].weeklyOffDays?.some(
                                            (value) => value?.label?.toLowerCase() === "none"
                                        )
                                            ? "can’t choose none as long as you has chosen any week days"
                                            : ""
                                    }
                                />
                            </FormGroup>
                            <FormGroup>
                                <Input
                                    isEditable
                                    label="Number of Working Days per Month"
                                    name="workingDatsPerMonth"
                                    type="number"
                                    onChange={(e) => {
                                        handleOnChangeInput(e, "workingDaysPerMonth");
                                    }}
                                    required
                                    placeholder="0"
                                    value={
                                        workingConditions[activeWorkingCondition]
                                            ?.workingDaysPerMonth || ""
                                    }
                                    max="30"
                                    min="1"
                                    error={
                                        !formIsValid &&
                                        (workingConditions[activeWorkingCondition]
                                            ?.workingDaysPerMonth === "" ||
                                            workingConditions[activeWorkingCondition]
                                                ?.workingDaysPerMonth === null ||
                                            workingConditions[activeWorkingCondition]
                                                ?.workingDaysPerMonth === undefined)
                                    }
                                />
                            </FormGroup>
                        </FormRow>
                        <FormRow>
                            <FormGroup>
                                <Input
                                    isEditable
                                    label="Working Hours per Day"
                                    name="workingHoursPerDay"
                                    type="number"
                                    onChange={(e) => {
                                        handleOnChangeInput(e, "workingHoursPerDay");
                                    }}
                                    required
                                    placeholder="0"
                                    value={
                                        workingConditions[activeWorkingCondition]
                                            ?.workingHoursPerDay || ""
                                    }
                                    max="24"
                                    min="1"
                                    error={
                                        !formIsValid &&
                                        (workingConditions[activeWorkingCondition]
                                            ?.workingHoursPerDay === "" ||
                                            workingConditions[activeWorkingCondition]
                                                ?.workingHoursPerDay === null ||
                                            workingConditions[activeWorkingCondition]
                                                ?.workingHoursPerDay === undefined)
                                    }
                                />
                            </FormGroup>
                            <FormGroup>
                                <MileageInput>
                                    <Input
                                        isEditable
                                        label="Mileage"
                                        name="Mileage"
                                        type="number"
                                        onChange={(e) => {
                                            handleOnChangeInput(e, "kiloMeters");
                                        }}
                                        required
                                        placeholder="0"
                                        value={
                                            workingConditions[activeWorkingCondition]?.kiloMeters ||
                                            ""
                                        }
                                        min="1"
                                        error={
                                            !formIsValid &&
                                            workingConditions[activeWorkingCondition]
                                                ?.kiloMeters === 0
                                        }
                                    />
                                    <MileageUnit>KM</MileageUnit>
                                </MileageInput>
                            </FormGroup>
                        </FormRow>
                        <SeparateLine />
                    </div>
                    <div>
                        <h3>Facilitators</h3>
                        <FormRow>
                            <FormGroup>
                                <Input
                                    isEditable
                                    label="No. of Helpers"
                                    name="numberOfHelpers"
                                    type="number"
                                    onChange={(e) => {
                                        handleOnChangeInput(e, "numberOfHelpers");
                                    }}
                                    required={false}
                                    placeholder="0"
                                    value={
                                        workingConditions[activeWorkingCondition]
                                            ?.numberOfHelpers || ""
                                    }
                                    min="0"
                                />
                            </FormGroup>
                            <FormGroup>
                                <Input
                                    isEditable
                                    label="No. of Delivery Delegates"
                                    name="numberOfDelegates"
                                    type="number"
                                    onChange={(e) => {
                                        handleOnChangeInput(e, "numberOfDelegates");
                                    }}
                                    required={false}
                                    placeholder="0"
                                    value={
                                        workingConditions[activeWorkingCondition]
                                            ?.numberOfDelegates || ""
                                    }
                                    min="0"
                                />
                            </FormGroup>
                        </FormRow>
                        <FormRow>
                            <CheckBox
                                label="does the client have special requirements for Facilitators ?
                                    "
                                name="facilitiesCheckbox"
                                type="checkbox"
                                onChange={(e) => {
                                    handleOnChangeCheckBox(e, "facilitiesCheckbox");
                                }}
                                value={
                                    workingConditions[activeWorkingCondition]?.facilitiesCheckbox ||
                                    false
                                }
                            />
                            {workingConditions[activeWorkingCondition]?.facilitiesCheckbox && (
                                <TextArea
                                    required={
                                        workingConditions[activeWorkingCondition]
                                            ?.facilitiesCheckbox
                                    }
                                    isEditable
                                    type="text"
                                    name="facilitiesSpecialRequired"
                                    onChange={(e) => {
                                        handleOnChangeInput(e, "facilitiesSpecialRequired");
                                    }}
                                    label=""
                                    placeholder=""
                                    value={
                                        workingConditions[activeWorkingCondition]
                                            .facilitiesSpecialRequired
                                    }
                                />
                            )}
                        </FormRow>
                        <SeparateLine />
                    </div>
                    <div>
                        <h3>Client Pricing Details</h3>

                        <FormRow>
                            <FormGroup>
                                <Input
                                    step="0.01"
                                    disableWithBorder={false}
                                    isEditable
                                    label="Truck price per month"
                                    name="truckPricePerMonth"
                                    type="number"
                                    onChange={(e) => {
                                        handleOnChangeInput(e, "truckPricePerMonth");
                                    }}
                                    required={!isRfq}
                                    value={
                                        workingConditions[activeWorkingCondition]
                                            ?.truckPricePerMonth
                                    }
                                    min={!isRfq && "1"}
                                    error={
                                        !formIsValid &&
                                        (workingConditions[activeWorkingCondition]
                                            ?.truckPricePerMonth === "" ||
                                            workingConditions[activeWorkingCondition]
                                                ?.truckPricePerMonth === 0)
                                    }
                                />
                            </FormGroup>
                            <FormGroup>
                                <Input
                                    step="0.01"
                                    disableWithBorder={false}
                                    isEditable
                                    label="Extra Day Price"
                                    name="extraDayPrice"
                                    type="number"
                                    onChange={(e) => {
                                        handleOnChangeInput(e, "extraDayPrice");
                                    }}
                                    required={!isRfq}
                                    value={workingConditions[activeWorkingCondition]?.extraDayPrice}
                                    min={!isRfq && "1"}
                                    error={
                                        !formIsValid &&
                                        (workingConditions[activeWorkingCondition]
                                            ?.extraDayPrice === 0 ||
                                            workingConditions[activeWorkingCondition]
                                                ?.extraDayPrice === "")
                                    }
                                />
                            </FormGroup>
                        </FormRow>
                        <FormRow>
                            <FormGroup>
                                <Input
                                    step="0.01"
                                    disableWithBorder={false}
                                    isEditable
                                    label="Extra Working Hour Price"
                                    name="extraHoursPrice"
                                    type="number"
                                    onChange={(e) => {
                                        handleOnChangeInput(e, "extraHoursPrice");
                                    }}
                                    required={!isRfq}
                                    value={
                                        workingConditions[activeWorkingCondition]?.extraHoursPrice
                                    }
                                    min={!isRfq && "1"}
                                    error={
                                        !formIsValid &&
                                        (workingConditions[activeWorkingCondition]
                                            ?.extraHoursPrice === 0 ||
                                            workingConditions[activeWorkingCondition]
                                                ?.extraHoursPrice === "")
                                    }
                                />
                            </FormGroup>
                            <FormGroup>
                                <Input
                                    step="0.01"
                                    disableWithBorder={false}
                                    isEditable
                                    label="Extra Kilometer Price"
                                    name="extraKiloMeterPrice"
                                    type="number"
                                    onChange={(e) => {
                                        handleOnChangeInput(e, "extraKiloMeterPrice");
                                    }}
                                    required={!isRfq}
                                    value={
                                        workingConditions[activeWorkingCondition]
                                            ?.extraKiloMeterPrice
                                    }
                                    min={!isRfq && "1"}
                                    error={
                                        !formIsValid &&
                                        (workingConditions[activeWorkingCondition]
                                            ?.extraKiloMeterPrice === 0 ||
                                            workingConditions[activeWorkingCondition]
                                                ?.extraKiloMeterPrice === "")
                                    }
                                />
                            </FormGroup>
                        </FormRow>
                        <FormRow>
                            <FormGroup>
                                <Input
                                    disableWithBorder={false}
                                    isEditable
                                    label="Over Night Stay Price %"
                                    name="overNightPrice"
                                    type="number"
                                    onChange={(e) => {
                                        handleOnChangeInput(e, "overNightPrice");
                                    }}
                                    required={
                                        workingConditions[activeWorkingCondition]?.workingOvernight
                                    }
                                    value={
                                        workingConditions[activeWorkingCondition]?.overNightPrice
                                    }
                                    min={!isRfq && "1"}
                                    max="100"
                                    error={
                                        !formIsValid &&
                                        (workingConditions[activeWorkingCondition]
                                            ?.overNightPrice === 0 ||
                                            workingConditions[activeWorkingCondition]
                                                ?.overNightPrice === "")
                                    }
                                />
                            </FormGroup>
                            <FormGroup>
                                <Input
                                    disableWithBorder={false}
                                    isEditable
                                    label="Truck daily price"
                                    name="truckDailyPrice"
                                    type="number"
                                    onChange={(e) => {
                                        handleOnChangeInput(e, "truckDailyPrice");
                                    }}
                                    required={
                                        // if project type is daily rental
                                        projectType?.value === 1
                                    }
                                    value={
                                        workingConditions[activeWorkingCondition]?.truckDailyPrice
                                    }
                                    error={
                                        !formIsValid &&
                                        projectType?.value === 1 &&
                                        (workingConditions[activeWorkingCondition]
                                            ?.truckDailyPrice === 0 ||
                                            workingConditions[activeWorkingCondition]
                                                ?.truckDailyPrice === "")
                                    }
                                />
                            </FormGroup>
                        </FormRow>
                        <FormRow>
                            <FormGroup>
                                <CheckBox
                                    label="Exclude Fuel & Oil"
                                    name="excludeGasAndOil"
                                    type="checkbox"
                                    onChange={(e) => {
                                        handleOnChangeCheckBox(e, "excludeGasAndOil");
                                    }}
                                    placeholder=""
                                    value={
                                        workingConditions[activeWorkingCondition]
                                            ?.excludeGasAndOil || false
                                    }
                                />
                            </FormGroup>
                        </FormRow>
                        {workingConditions[activeWorkingCondition]?.excludeGasAndOil && (
                            <FormRow>
                                <FormGroup>
                                    <Input
                                        disableWithBorder={false}
                                        isEditable
                                        step="0.01"
                                        label="Oil Price per Kilometer"
                                        name="oilPricePerKilometer"
                                        type="number"
                                        onChange={(e) => {
                                            handleOnChangeInput(e, "oilPricePerKilometer");
                                        }}
                                        required={
                                            workingConditions[activeWorkingCondition]
                                                ?.excludeGasAndOil
                                        }
                                        placeholder="1"
                                        value={
                                            workingConditions[activeWorkingCondition]
                                                ?.oilPricePerKilometer
                                        }
                                        min="1"
                                        error={
                                            !formIsValid &&
                                            (workingConditions[activeWorkingCondition]
                                                ?.oilPricePerKilometer === 0 ||
                                                workingConditions[activeWorkingCondition]
                                                    ?.oilPricePerKilometer === "")
                                        }
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <Input
                                        disableWithBorder={false}
                                        isEditable
                                        step="0.01"
                                        label="Fuel Price per Kilometer"
                                        name="fuelPricePerKilometer"
                                        type="number"
                                        onChange={(e) => {
                                            handleOnChangeInput(e, "fuelPricePerKilometer");
                                        }}
                                        required={
                                            workingConditions[activeWorkingCondition]
                                                ?.excludeGasAndOil
                                        }
                                        placeholder="1"
                                        value={
                                            workingConditions[activeWorkingCondition]
                                                ?.fuelPricePerKilometer
                                        }
                                        min="1"
                                        error={
                                            !formIsValid &&
                                            (workingConditions[activeWorkingCondition]
                                                ?.fuelPricePerKilometer === 0 ||
                                                workingConditions[activeWorkingCondition]
                                                    ?.fuelPricePerKilometer === "")
                                        }
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <StyledLabel>Total Fuel & Oil Price </StyledLabel>

                                    {workingConditions[activeWorkingCondition]?.kiloMeters &&
                                        workingConditions[activeWorkingCondition]
                                            ?.gasAndOilPerUnitDistance && (
                                            <DataView>
                                                {Number(
                                                    workingConditions[activeWorkingCondition]
                                                        ?.kiloMeters
                                                ) *
                                                    Number(
                                                        workingConditions[activeWorkingCondition]
                                                            ?.gasAndOilPerUnitDistance
                                                    )}
                                            </DataView>
                                        )}
                                </FormGroup>
                            </FormRow>
                        )}
                        <FormRow>
                            <FormGroup>
                                <Input
                                    disableWithBorder={false}
                                    isEditable
                                    label="Helper Daily Wage"
                                    name="helperWage"
                                    type="number"
                                    onChange={(e) => {
                                        handleOnChangeInput(e, "helperWage");
                                    }}
                                    required={
                                        !isRfq &&
                                        workingConditions[activeWorkingCondition]?.numberOfHelpers >
                                            0
                                    }
                                    value={
                                        workingConditions[activeWorkingCondition]?.helperWage || ""
                                    }
                                    min="0"
                                    error={
                                        !formIsValid &&
                                        !isRfq &&
                                        (workingConditions[activeWorkingCondition]?.helperWage ===
                                            0 ||
                                            workingConditions[activeWorkingCondition]
                                                ?.helperWage === "")
                                    }
                                />
                            </FormGroup>
                            <FormGroup>
                                <Input
                                    disableWithBorder={false}
                                    isEditable
                                    label="Delegate Monthly Wage"
                                    name="delegateWage"
                                    type="number"
                                    onChange={(e) => {
                                        handleOnChangeInput(e, "delegateWage");
                                    }}
                                    required={
                                        !isRfq &&
                                        workingConditions[activeWorkingCondition]
                                            ?.numberOfDelegates > 0
                                    }
                                    value={
                                        workingConditions[activeWorkingCondition]?.delegateWage ||
                                        ""
                                    }
                                    min="0"
                                    error={
                                        !formIsValid &&
                                        !isRfq &&
                                        (workingConditions[activeWorkingCondition]?.delegateWage ===
                                            0 ||
                                            workingConditions[activeWorkingCondition]
                                                ?.delegateWage === "")
                                    }
                                />
                            </FormGroup>
                        </FormRow>

                        <SeparateLine />
                    </div>
                </ProjectCondition>
            </div>
            <FormRow>
                <ConfirmSpo>
                    <CheckBox
                        label="Please Confirm that you had communicated All ILLA’s SOPs with the Client ?
                            "
                        name="confirmSops"
                        type="checkbox"
                        onChange={(e) => setConfirmSops(e.target.checked)}
                        required
                        error={!formIsValid && confirmSops === false}
                        value={confirmSops}
                    />
                </ConfirmSpo>
            </FormRow>
            {!formIsValid && (
                <FormRow>
                    <ErrorHint>
                        <Error>Please Fill the Required Field</Error>
                    </ErrorHint>
                </FormRow>
            )}
            <ButtonRow>
                <Button
                    type="submit"
                    name={isLoading ? <Spinner /> : "Submit"}
                    btnStyle="primaryBtn"
                />
            </ButtonRow>
        </FormStyle>
    );
}
